<template>
    <div class="row subtitle-proofread-cue">
        <div class="col-xs-1" style="line-height: 2em;">
            <span :class="{ 'text-success': approved, 'text-danger': rejected }">
              #{{ number }}
            </span>
            <i class="fa fa-lg fa-check proofread-check" @click="approve" :class="{ 'text-success': approved }"></i>
        </div>
        <div class="col-xs-11">
            <div class="row" :class="{ 'text-success': approved, 'text-danger': rejected }">
                <input type="checkbox" :value="number" name="approved[]" :checked="approved"/>

                <div class="col-xs-3 ">
                    <p dir="auto" style="padding-bottom: 5px; line-height: 2em;" v-html="masterLines"></p>
                </div>

                <div class="col-xs-5">
                  <i
                      style="margin-left: 5px;"
                      class="fa fa-eye tool_tip"
                      :title="translatedLines"
                      data-toggle="tooltip">

                  </i>
                  <subtitle-cue-textarea
                      :lines="wipLines"
                      :name="'edits[' + number + ']'"
                      :required="'required'"
                      :disabled="approved || rejected"
                  ></subtitle-cue-textarea>
                </div>

                <div class="col-xs-4" v-if="showFinishedLanguages">
                    <p v-for="(cue, language_id) in finishedLanguageLines" :data-language-id="language_id"
                       class="hideable-by-language" dir="auto" style="padding-bottom: 5px; line-height: 2em;"
                       v-html="cue === '' ? 'not yet translated...' : cue.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + '<br />' + '$2')">
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'number',
            'masterLines',
            'showFinishedLanguages',
            'finishedLanguageLines',
            'translatedLines',
            'wipLines',
            'isRejected',
            'isApproved',
        ],

        data: function() {
            return {
                markedAsApproved: null,
                markedAsRejected: null,
            };
        },

        mounted() {
            this.markedAsApproved = this.isApproved;
            this.markedAsRejected = this.isRejected;
        },

        computed: {
            approved: function() {
                return this.markedAsApproved === null ? this.isApproved : this.markedAsApproved;
            },
            rejected: function() {
                return this.markedAsRejected !== null ? this.markedAsRejected : this.isRejected;
            },
        },

        methods: {
            approve: function() {
                this.markedAsApproved = !this.markedAsApproved;
                this.markedAsRejected = false;
            },
            reject: function() {
                this.markedAsApproved = false;
                this.markedAsRejected = !this.markedAsRejected;
            },
        },
    };
</script>

<style>
    .subtitle-proofread-cue .fa {
        cursor: pointer;
    }

    .subtitle-proofread-cue input[type='checkbox'] {
        display: none;
    }
</style>
